var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmotionDislike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 34,
    viewBox: "0 0 35 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4467 32.75C26.2204 32.75 33.3456 25.7055 33.3456 17C33.3456 8.29455 26.2204 1.25 17.4467 1.25C8.67302 1.25 1.54785 8.29455 1.54785 17C1.54785 25.7055 8.67302 32.75 17.4467 32.75Z",
    fill: "url(#paint0_linear_7022_33095)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7022_33095)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.0647 18.6466C20.2078 18.6466 20.3133 18.6466 20.4196 18.6466C21.8575 18.6466 23.2955 18.653 24.7334 18.6426C25.4144 18.6378 25.9347 18.1982 26.0602 17.5651C26.1801 16.9616 25.8652 16.3614 25.2873 16.0912C25.2266 16.0624 25.165 16.0353 25.1019 16.0065C25.838 15.1752 25.6542 14.1153 24.5791 13.6429C25.4312 12.6294 24.8989 11.6151 24.026 11.3034C24.054 11.2618 24.0756 11.2235 24.1036 11.1915C24.4888 10.7503 24.5831 10.2531 24.3465 9.71839C24.1012 9.16607 23.6392 8.92068 23.0509 8.92388C21.8527 8.93107 20.6546 8.95266 19.4564 8.96784C18.1887 8.98383 16.9202 8.99742 15.6526 9.0158C14.9412 9.02619 14.5679 9.40586 14.5671 10.1172C14.5655 12.5335 14.5743 14.9506 14.5591 17.3669C14.5567 17.8081 14.6718 18.1854 14.9732 18.4819C15.627 19.1253 16.3056 19.7432 16.9722 20.3738C17.3854 20.7647 17.7995 21.154 18.2055 21.5528C18.5508 21.8925 18.6867 22.3145 18.7019 22.7965C18.7203 23.384 18.7522 23.9739 18.8218 24.5574C18.8809 25.0569 19.0048 25.1241 19.4996 25.0561C20.4723 24.9235 21.0278 24.3384 21.1645 23.3432C21.2924 22.4073 21.111 21.5121 20.8264 20.6352C20.633 20.0389 20.378 19.4634 20.151 18.8784C20.127 18.8168 20.1047 18.7545 20.0655 18.6482L20.0647 18.6466Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.92325 13.8252C8.92325 15.0633 8.92165 16.3022 8.92325 17.5403C8.92405 18.2533 9.29892 18.6314 10.0111 18.6354C10.84 18.6394 11.6688 18.6402 12.4977 18.6354C13.1875 18.6314 13.576 18.2501 13.5768 17.5563C13.5816 15.0697 13.5824 12.5831 13.5768 10.0964C13.5752 9.40266 13.1859 9.02059 12.4969 9.0166C11.6585 9.0118 10.8192 9.011 9.97993 9.0166C9.30612 9.02139 8.92405 9.40825 8.92245 10.0805C8.92005 11.329 8.92245 12.5775 8.92245 13.8252H8.92325Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7022_33095",
    x1: 17.4467,
    y1: 2,
    x2: 17.4467,
    y2: 32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#727272"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#181818"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7022_33095"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.1618,
    height: 16.1538,
    fill: "white",
    transform: "matrix(1 0 0 -1 8.92334 25.0769)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmotionDislike);
export default __webpack_public_path__ + "static/media/emotion_dislike.9db27fee816c3f9ee620dcb79b4987fc.svg";
export { ForwardRef as ReactComponent };